import { Controller } from "@hotwired/stimulus"
import { categoriesCount } from "../modules/product_wizard.mjs"

// Chips de categorías con tope: al máximo, las no elegidas se deshabilitan; publica chip-limit:change.
// Doc: _docs/features/products/partner_product_form.md
export default class extends Controller {
  static targets = ["chip", "count"]
  static values = { max: { type: Number, default: 2 } }

  connect() {
    this.update()
  }

  // Borrador local: ids marcados; al restaurar se respeta el tope y se omite lo que ya no existe
  get draft() {
    return this.chipTargets.filter(chip => chip.checked).map(chip => Number(chip.value))
  }

  restoreDraft(ids) {
    const wanted = (ids || []).map(Number).slice(0, this.maxValue)
    let found = 0
    this.chipTargets.forEach(chip => {
      const on = wanted.includes(Number(chip.value))
      chip.checked = on
      if (on) found += 1
    })
    this.update()
    return { skipped: wanted.length - found }
  }

  update() {
    const checked = this.chipTargets.filter(chip => chip.checked).length
    const full = checked >= this.maxValue
    this.chipTargets.forEach(chip => {
      const blocked = full && !chip.checked
      chip.disabled = blocked
      chip.closest(".chip")?.classList.toggle("is-blocked", blocked)
    })
    this.element.classList.toggle("is-full", full)
    if (this.hasCountTarget) this.countTarget.textContent = categoriesCount(checked, this.maxValue)
    this.dispatch("change", { detail: { count: checked } })
  }
}
